import type { Status } from './types';

export const statusLabel: Record<Status, string> = {
  ok: 'Óptimo',
  warn: 'Mejorable',
  crit: 'Prioritario',
};

export const examCountLabel = (n: number): string =>
  n === 1 ? '1 examen' : `${n} exámenes`;
